import { render, staticRenderFns } from "./RoleCreateModal.vue?vue&type=template&id=418a57b0&scoped=true"
import script from "./RoleCreateModal.vue?vue&type=script&lang=js"
export * from "./RoleCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a57b0",
  null
  
)

export default component.exports